export default __webpack_public_path__ + "static/media/3.6c93fe6c.png";